import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { DecimalPipe } from "@angular/common";
import { Observable } from "rxjs";
import { catchError, retry } from "rxjs/operators";

import { machineData } from "./machine_interface";
import { CountryService } from "./country.service";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";
import { NgbdSortableHeader, SortEvent } from "./sortable.directive";
import { TimeZoneUtils } from "../utils/timezone.utils";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";
import { SystemUtils } from "../utils/system.utils";

@Component({
  selector: "app-machine",
  templateUrl: "./machine.component.html",
  styleUrls: ["./machine.component.css"],
  providers: [CountryService, DecimalPipe],
})
export class MachineComponent implements OnInit {
  isShown: boolean = false;
  iscustomSelected: boolean = true;
  isLoading: boolean = false;
  ismachineProfileSelected: boolean = false;
  machineLists: any = [];
  displayMachineLists: any = [];
  systemList: any = [];
  envList: any = [];
  filterArray: any = [];
  filterArraySize: any = 0;

  isFailure: boolean = false;
  failureMessage: any = "";
  isSuccess: boolean = false;
  successMessage: any = "";

  mnid: any = "";
  machineID: any = "";
  environment: any = "";
  hostname: any = "";
  status: any = "";
  machineName: any = "";
  selectedMachine: any = "";
  Totalmachines: any = "";
  notConfigure: any = "";
  importedDate: any = "";
  modifiedDate: any = "";
  deleteMachineLength: any = 0;
  environmentId: any = "";
  masterEnvId: any = "";
  envType: any = "AA";

  machineListWithChild: any = [];
  machineListWithoutChild: any = [];
  machineOrgIdParentENV: any = "";

  isMachineIdSorted: boolean = false;
  isMachineNameSorted: boolean = false;
  isMachineStatusSorted: boolean = false;
  isMachineLastUpdatedSorted: boolean = false;
  isConfigEdit: any = 0;
  isAccessEdit: any = 0;

  showBulkEdit = false;
  setConfigStatus = false;
  selectedMachines = new Set();
  selectedMachined: any;

  edit: any = "../../assets/images/icons/edit.png";

  countries$: Observable<machineData[]>;
  total$: Observable<number>;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    public service: CountryService,
    private _restService: RestService,
    private router: Router
  ) {
    this.countries$ = this.machineLists;
    this.total$ = service.total$;
  }

  ngOnInit() {
    this._restService
      .getMachineLists()
      .pipe(
        catchError((e) => {
          // (this.isLoading = false),
          //   (this.isFailure = true),
          //   (this.failureMessage = e.error.response === "" ? e.error.StatusInfo :  e.error.response);
          // console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (d: any) => (
          (this.machineLists = d.machineList),
          (this.filterArray = d.machineList),
          (d.machineList.forEach(m => {
            m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
            m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
          })),
          (this.filterArraySize = d.machineList.length),
          (this.Totalmachines = d.machineListLength),
          (this.notConfigure = d.notConfigured),
          (this.deleteMachineLength = d.deleteMachine),
          console.log(
            "Data filterArray list ----------------->>>>>>>",
            this.filterArray.length
          )
        )
      );

      this.environmentId = 'All';

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          // (this.isLoading = false),
          //   (this.isFailure = true),
          //   (this.failureMessage = e.error.response === "" ? e.error.StatusInfo :  e.error.response);
          // console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.envList = f.EnvList),
          console.log("Data from Machine list", f.EnvList)
        )
      );
  }

  closeInfo() {
    this.deleteMachineLength = 0;
  }

  onChangeStatus(e: any) {
    this.isConfigEdit = 1;
  }

  machineIdSorted() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isMachineIdSorted === false) {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return a.MachineId - b.MachineId;
      });
      this.isMachineIdSorted = true;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    } else {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return b.MachineId - a.MachineId;
      });
      this.isMachineIdSorted = false;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    }
  }

  machineNameSorted() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isMachineNameSorted === false) {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return a.MachineName.localeCompare(b.MachineName);
      });
      this.isMachineNameSorted = true;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    } else {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return b.MachineName.localeCompare(a.MachineName);
      });
      this.isMachineNameSorted = false;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    }
  }

  machineStatusSorted() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isMachineStatusSorted === false) {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return a.configured - b.configured;
      });
      this.isMachineStatusSorted = true;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    } else {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return b.configured - a.configured;
      });
      this.isMachineStatusSorted = false;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    }
  }

  machineLastUpdatedSorted() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isMachineLastUpdatedSorted === false) {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return a.ModifiedDate.localeCompare(b.ModifiedDate);
      });
      this.isMachineLastUpdatedSorted = true;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    } else {
      sortedList = this.machineLists.sort(function (a: any, b: any) {
        return b.ModifiedDate.localeCompare(a.ModifiedDate);
      });
      this.isMachineLastUpdatedSorted = false;
      this.filterArray = sortedList;
      this.filterArraySize = sortedList.length;
    }
  }

  customEvent(e: any) {
    e.target.checked === true
      ? ((this.iscustomSelected = true),
        (this.ismachineProfileSelected = false))
      : (this.iscustomSelected = false);
  }

  machineProfileEvent(e: any) {
    this.displayMachineLists = this.machineLists.filter(m => m.DisplayEnvName === this.environment);
    this.selectedMachine = "";
    e.target.checked === true
      ? ((this.ismachineProfileSelected = true),
        (this.iscustomSelected = false))
      : (this.ismachineProfileSelected = false);
  }

  onEditMachine(
    id: any,
    mid: any,
    environment: any,
    mname: any,
    hostname: any,
    configStatus: any,
    machineOrgIdParentENV: any,
    importedDate: any,
    modifiedDate: any,
    environmentId: any,
    menvid: any,
    envType: any
  ) {
    this.isShown = true;
    this.mnid = id;
    this.machineID = mid;
    this.environment = environment;
    this.hostname = hostname;
    this.status = configStatus;
    this.machineName = mname;
    this.machineOrgIdParentENV = machineOrgIdParentENV;
    this.importedDate = importedDate;
    this.modifiedDate = modifiedDate;
    this.environmentId = environmentId;
    this.masterEnvId = menvid;
    this.envType = envType;

    console.log("Machine", this.filterArray);

    this.iscustomSelected = true;
    this.ismachineProfileSelected = false;

    this.isLoading = true;
    this.getMachineDetail(machineOrgIdParentENV, mid, envType);
  }

  levelTwoEvent(id: any) {
    this.isAccessEdit = 1;
    let list = this.systemList;
    list.map((f: any) =>
      f.categoryId === id ? (f.ShowChild = !f.ShowChild) : ""
    );
    this.systemList = list;
  }

  collapseEvent(c1: any) {
    let list = this.systemList;
    list.map((a: any) =>
      a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? (b.ShowChild = !b.ShowChild)
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? (c.ShowChild = !c.ShowChild)
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? (d.ShowChild = !d.ShowChild)
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? (f.ShowChild = !f.ShowChild)
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? (g.ShowChild = !g.ShowChild)
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? (h.ShowChild = !h.ShowChild)
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? (j.ShowChild = !j.ShowChild)
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? (k.ShowChild = !k.ShowChild)
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );
  }

  selectEnvironmentMachine(e: any) { 
    let machineId = e.target.value;
    this.selectedMachine = this.filterArray.find(m => m.id = machineId);
  }

  selectEnvironment(e: any) {
    this.isLoading = true;
    console.log("E", e.target.value);
    console.log("Filter", this.filterArray);
    let environmentID: any = e.target.value;
    this.environmentId = environmentID;

    console.log(environmentID);

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(environmentID)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    this.showBulkEdit = environmentID === "All" ? false : true;
    this.setConfigStatus = false;
    this.selectedMachines.clear()
    this.selectedMachine = undefined;

    environmentID === "All"
      ? this._restService
          .getMachineLists()
          .pipe(
            catchError((e) => {
              // (this.isLoading = false),
              //   (this.isFailure = true),
              //   (this.failureMessage = e.error.response === "" ? e.error.StatusInfo :  e.error.response);
              // console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.machineLists = d.machineList),
              (this.filterArray = d.machineList),
              (d.machineList.forEach(m => {
                m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
              })),
              (this.filterArraySize = d.machineList.length),
              (this.Totalmachines = d.machineListLength),
              (this.notConfigure = d.notConfigured),
              (this.deleteMachineLength = d.deleteMachine),
              (this.isLoading = false),
              console.log(
                "Data filterArray list ----------------->>>>>>>",
                this.filterArray.length
              )
            )
          )
      : this._restService
          .filterMachineList(environmentID)
          .pipe(
            catchError((e) => {
              (this.isLoading = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.StatusInfo);
              console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.filterArray = []),
              (this.machineLists = d.machineList),
              (this.filterArray = d.machineList),
              (this.filterArraySize = d.machineList.length),
              (this.Totalmachines = d.machineListLength),
              (this.notConfigure = d.notConfigured),
              (this.deleteMachineLength = d.deleteMachine),
              (this.isLoading = false)
            )
          );
  }

  close() {
    this.isShown = false;
    this.iscustomSelected = true;
    this.ismachineProfileSelected = false;
    this.selectedMachine = "";

    this.showBulkEdit = this.environmentId === "All" ? false : true;
    this.setConfigStatus = false;
    this.selectedMachines.clear()
    this.selectedMachine = undefined;

    this.environmentId === "All"
      ? this._restService
          .getMachineLists()
          .pipe(
            catchError((e) => {
              // (this.isLoading = false),
              //   (this.isFailure = true),
              //   (this.failureMessage = e.error.response === "" ? e.error.StatusInfo :  e.error.response);
              // console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.machineLists = d.machineList),
              (this.filterArray = d.machineList),
              (d.machineList.forEach(m => {
                m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
              })),
              (this.filterArraySize = d.machineList.length),
              (this.Totalmachines = d.machineListLength),
              (this.notConfigure = d.notConfigured),
              (this.deleteMachineLength = d.deleteMachine),
              (this.isLoading = false),
              console.log(
                "Data filterArray list ----------------->>>>>>>",
                this.filterArray.length
              )
            )
          )
      : this._restService
          .filterMachineList(this.environmentId)
          .pipe(
            catchError((e) => {
              (this.isLoading = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.StatusInfo);
              console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.filterArray = []),
              (this.machineLists = d.machineList),
              (this.filterArray = d.machineList),
              (this.filterArraySize = d.machineList.length),
              (this.Totalmachines = d.machineListLength),
              (this.notConfigure = d.notConfigured),
              (this.deleteMachineLength = d.deleteMachine),
              (this.isLoading = false)
            )
          );
  }

  getMachineDetail(id, mid, envType) {

    return new Promise ((res, rej) => {
      this._restService
      .getMachineDetail(id, mid, this.masterEnvId, envType)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          rej(e);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log(
            "Machine Details List ---------------------->>>>>",
            f.systemAccess
          ),
          f.systemAccess.map(
            (a: any) => (
              (a.isSystemEdited = false),
              a.hasOwnProperty("children")
                ? a.children.map(
                    (b: any) => (
                      (b.isSystemEdited = false),
                      b.hasOwnProperty("children")
                        ? b.children.map(
                            (c: any) => (
                              (c.isSystemEdited = false),
                              c.hasOwnProperty("children")
                                ? c.children.map(
                                    (d: any) => (
                                      (d.isSystemEdited = false),
                                      d.hasOwnProperty("children")
                                        ? d.children.map(
                                            (f: any) =>
                                              (f.isSystemEdited = false),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    (g.isSystemEdited = false),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            (h.isSystemEdited = false),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    (j.isSystemEdited = false),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            k: any
                                                                          ) => (
                                                                            (k.isSystemEdited = false),
                                                                            k.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? k.children.map(
                                                                                  (
                                                                                    l: any
                                                                                  ) =>
                                                                                    (l.isSystemEdited = false)
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                : ""
            )
          ),
          (this.systemList = f.systemAccess),
          (SystemUtils.sortSystemAccess(this.systemList)),
          (this.isLoading = false),
          res(f)
        )
      );
    }); 
    
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = "";
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  copyMachineID(id: any) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = id;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  isChecked2(cId: any) {
    const accessMap = {};
    this.buildAccessMap(this.systemList, accessMap);
    this.isAccessEdit = 1;

    const newVal = !accessMap[cId].isChecked;
    this.updateAccess(accessMap[cId], newVal);

    if (newVal) {
      while (accessMap[cId].parentId != 0 ) {
        cId = accessMap[cId].parentId;

        if (accessMap[cId].isChecked) {
          break;
        }
        accessMap[cId].isChecked = newVal;
        accessMap[cId].isSystemEdited = true;
      }
    } 
  }

  updateAccess(access: any, val: boolean) {
    access.isChecked = val;
    access.isSystemEdited = true;

    if (access.children){
      access.children.forEach( child => this.updateAccess(child, val));
    }
  }

  buildAccessMap(accessList: any, map: any) {
    if (!accessList)
      return map;

    accessList.forEach(access => {
      map[access.categoryId] = access;

      this.buildAccessMap(access.children, map);
    })
  }


  isChecked(c1: any) {
    let list = this.systemList;
    this.isAccessEdit = 1;
    list.map((f: any) =>
      f.categoryId === c1
        ? ((f.isChecked = !f.isChecked), (f.isSystemEdited = true))
        : ""
    ),
      list.map((a: any) =>
        a.hasOwnProperty("children")
          ? a.children.map((b: any) =>
              b.categoryId === c1
                ? ((b.isChecked = !b.isChecked), (b.isSystemEdited = true))
                : b.hasOwnProperty("children")
                ? b.children.map((c: any) =>
                    c.categoryId === c1
                      ? ((c.isChecked = !c.isChecked),
                        (c.isSystemEdited = true))
                      : c.hasOwnProperty("children")
                      ? c.children.map((d: any) =>
                          d.categoryId === c1
                            ? ((d.isChecked = !d.isChecked),
                              (d.isSystemEdited = true))
                            : d.hasOwnProperty("children")
                            ? d.children.map((f: any) =>
                                f.categoryId === c1
                                  ? ((f.isChecked = !f.isChecked),
                                    (f.isSystemEdited = true))
                                  : f.hasOwnProperty("children")
                                  ? f.children.map((g: any) =>
                                      g.categoryId === c1
                                        ? ((g.isChecked = !g.isChecked),
                                          (g.isSystemEdited = true))
                                        : g.hasOwnProperty("children")
                                        ? g.children.map((h: any) =>
                                            h.categoryId === c1
                                              ? ((h.isChecked = !h.isChecked),
                                                (h.isSystemEdited = true))
                                              : h.hasOwnProperty("children")
                                              ? h.children.map((j: any) =>
                                                  j.categoryId === c1
                                                    ? ((j.isChecked = !j.isChecked),
                                                      (j.isSystemEdited = true))
                                                    : j.hasOwnProperty(
                                                        "children"
                                                      )
                                                    ? j.children.map((k: any) =>
                                                        k.categoryId === c1
                                                          ? ((k.isChecked = !k.isChecked),
                                                            (k.isSystemEdited = true))
                                                          : k.hasOwnProperty(
                                                              "children"
                                                            )
                                                          ? k.children.map(
                                                              (l: any) =>
                                                                l.categoryId ===
                                                                c1
                                                                  ? ((l.isChecked = !l.isChecked),
                                                                    (l.isSystemEdited = true))
                                                                  : ""
                                                            )
                                                          : ""
                                                      )
                                                    : ""
                                                )
                                              : ""
                                          )
                                        : ""
                                    )
                                  : ""
                              )
                            : ""
                        )
                      : ""
                  )
                : ""
            )
          : ""
      );

    list.map((a: any) =>
      a.categoryId === c1
        ? a.isChecked === false
          ? this.parentChildRelation(c1, a.children, false)
          : this.parentChildRelation(c1, a.children, true)
        : a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? b.isChecked === false
                ? this.parentChildRelation(c1, b.children, false)
                : this.parentChildRelation(c1, b.children, true)
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? c.isChecked === false
                      ? this.parentChildRelation(c1, c.children, false)
                      : this.parentChildRelation(c1, c.children, true)
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? d.isChecked === false
                            ? this.parentChildRelation(c1, d.children, false)
                            : this.parentChildRelation(c1, d.children, true)
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? f.isChecked === false
                                  ? this.parentChildRelation(
                                      c1,
                                      f.children,
                                      false
                                    )
                                  : this.parentChildRelation(
                                      c1,
                                      f.children,
                                      true
                                    )
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? g.isChecked === false
                                        ? this.parentChildRelation(
                                            c1,
                                            g.children,
                                            false
                                          )
                                        : this.parentChildRelation(
                                            c1,
                                            g.children,
                                            true
                                          )
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? h.isChecked === false
                                              ? this.parentChildRelation(
                                                  c1,
                                                  h.children,
                                                  false
                                                )
                                              : this.parentChildRelation(
                                                  c1,
                                                  h.children,
                                                  true
                                                )
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? j.isChecked === false
                                                    ? this.parentChildRelation(
                                                        c1,
                                                        j.children,
                                                        false
                                                      )
                                                    : this.parentChildRelation(
                                                        c1,
                                                        j.children,
                                                        true
                                                      )
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? k.isChecked === false
                                                          ? this.parentChildRelation(
                                                              c1,
                                                              k.children,
                                                              false
                                                            )
                                                          : this.parentChildRelation(
                                                              c1,
                                                              k.children,
                                                              true
                                                            )
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? l.isChecked ===
                                                                  false
                                                                  ? this.parentChildRelation(
                                                                      c1,
                                                                      l.children,
                                                                      false
                                                                    )
                                                                  : this.parentChildRelation(
                                                                      c1,
                                                                      l.children,
                                                                      true
                                                                    )
                                                                : l.hasOwnProperty(
                                                                    "children"
                                                                  )
                                                                ? l.children.map(
                                                                    (m: any) =>
                                                                      m.categoryId ===
                                                                      c1
                                                                        ? m.isChecked ===
                                                                          false
                                                                          ? this.parentChildRelation(
                                                                              c1,
                                                                              m.children,
                                                                              false
                                                                            )
                                                                          : this.parentChildRelation(
                                                                              c1,
                                                                              m.children,
                                                                              true
                                                                            )
                                                                        : ""
                                                                  )
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );
  }

  parentChildRelation(c1: any, childArray: any, status: any) {
    console.log(c1);
    console.log(childArray);

    console.log("Before asasas ---->>>>", this.systemList);

    if (!childArray){
      return;
    }

    let disabledArray: any;

    status === false
      ? childArray.map(
          (a: any) => (
            ((a.isChecked = false),
            (a.isEnabled = false),
            (a.isSystemEdited = true)),
            a.hasOwnProperty("children")
              ? a.children.map(
                  (b: any) => (
                    ((b.isChecked = false),
                    (b.isEnabled = false),
                    (b.isSystemEdited = true)),
                    b.hasOwnProperty("children")
                      ? b.children.map(
                          (c: any) => (
                            ((c.isChecked = false),
                            (c.isEnabled = false),
                            (c.isSystemEdited = true)),
                            c.hasOwnProperty("children")
                              ? c.children.map(
                                  (d: any) => (
                                    ((d.isChecked = false),
                                    (d.isEnabled = false),
                                    (d.isSystemEdited = true)),
                                    d.hasOwnProperty("children")
                                      ? d.children.map(
                                          (f: any) => (
                                            ((f.isChecked = false),
                                            (f.isEnabled = false),
                                            (f.isSystemEdited = true)),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    ((g.isChecked = false),
                                                    (g.isEnabled = false),
                                                    (g.isSystemEdited = true)),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            (h.isChecked = false),
                                                            (h.isEnabled = false),
                                                            (h.isSystemEdited = true),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    ((j.isChecked = false),
                                                                    (j.isEnabled = false),
                                                                    (j.isSystemEdited = true)),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            k: any
                                                                          ) => (
                                                                            ((k.isChecked = false),
                                                                            (k.isEnabled = false),
                                                                            (k.isSystemEdited = true)),
                                                                            k.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? k.children.map(
                                                                                  (
                                                                                    l: any
                                                                                  ) => (
                                                                                    ((l.isChecked = false),
                                                                                    (l.isEnabled = false),
                                                                                    (l.isSystemEdited = true)),
                                                                                    l.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? l.children.map(
                                                                                          (
                                                                                            m: any
                                                                                          ) => (
                                                                                            (m.isChecked = false),
                                                                                            (m.isEnabled = false),
                                                                                            (m.isSystemEdited = true)
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          )
        )
      : status === true
      ? childArray.map(
          (a: any) => (
            ((a.isChecked = true), (a.isEnabled = true)),
            a.hasOwnProperty("children")
              ? a.children.map(
                  (b: any) => (
                    ((b.isChecked = true), (b.isEnabled = true)),
                    b.hasOwnProperty("children")
                      ? b.children.map(
                          (c: any) => (
                            ((c.isChecked = true), (c.isEnabled = true)),
                            c.hasOwnProperty("children")
                              ? c.children.map(
                                  (d: any) => (
                                    ((d.isChecked = true),
                                    (d.isEnabled = true)),
                                    d.hasOwnProperty("children")
                                      ? d.children.map(
                                          (f: any) => (
                                            ((f.isChecked = true),
                                            (f.isEnabled = true)),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    ((g.isChecked = true),
                                                    (g.isEnabled = true)),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            ((h.isChecked = true),
                                                            (h.isEnabled = true)),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    ((j.isChecked = true),
                                                                    (j.isEnabled = true)),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            h: any
                                                                          ) => (
                                                                            ((h.isChecked = true),
                                                                            (h.isEnabled = true)),
                                                                            h.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? h.children.map(
                                                                                  (
                                                                                    j: any
                                                                                  ) => (
                                                                                    ((j.isChecked = true),
                                                                                    (j.isEnabled = true)),
                                                                                    j.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? j.children.map(
                                                                                          (
                                                                                            k: any
                                                                                          ) => (
                                                                                            ((k.isChecked = true),
                                                                                            (k.isEnabled = true)),
                                                                                            k.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? k.children.map(
                                                                                                  (
                                                                                                    l: any
                                                                                                  ) => (
                                                                                                    ((l.isChecked = true),
                                                                                                    (l.isEnabled = true)),
                                                                                                    l.hasOwnProperty(
                                                                                                      "children"
                                                                                                    )
                                                                                                      ? l.children.map(
                                                                                                          (
                                                                                                            m: any
                                                                                                          ) => (
                                                                                                            ((m.isChecked = true),
                                                                                                            (m.isEnabled = true)),
                                                                                                            m.hasOwnProperty(
                                                                                                              "children"
                                                                                                            )
                                                                                                              ? ""
                                                                                                              : ""
                                                                                                          )
                                                                                                        )
                                                                                                      : ""
                                                                                                  )
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          )
        )
      : "";

    disabledArray = this.systemList;

    disabledArray.map((a: any) =>
      a.categoryId === c1
        ? ((a.children = []), (a.children = childArray))
        : a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? ((b.children = []), (b.children = childArray))
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? ((c.children = []), (c.children = childArray))
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? ((d.children = []), (d.children = childArray))
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? ((f.children = []), (f.children = childArray))
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? ((g.children = []),
                                        (g.children = childArray))
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? ((h.children = []),
                                              (h.children = childArray))
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? ((j.children = []),
                                                    (j.children = childArray))
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? ((k.children = []),
                                                          (k.children = childArray))
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? ((l.children = []),
                                                                  (l.children = childArray))
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );

    this.systemList = disabledArray;
    console.log("After asasas ---->>>>", this.systemList);
  }


  saveMachineDetails() {
    console.log("Maari", this.systemList);
    (this.machineListWithChild = []),
      (this.isLoading = true),
      this.systemList.map(
        (a: any) => (
          this.machineListWithChild.push(a),
          a.hasOwnProperty("children")
            ? a.children.map(
                (b: any) => (
                  this.machineListWithChild.push(b),
                  b.hasOwnProperty("children")
                    ? b.children.map(
                        (c: any) => (
                          this.machineListWithChild.push(c),
                          c.hasOwnProperty("children")
                            ? c.children.map(
                                (d: any) => (
                                  this.machineListWithChild.push(d),
                                  d.hasOwnProperty("children")
                                    ? d.children.map(
                                        (f: any) => (
                                          this.machineListWithChild.push(f),
                                          f.hasOwnProperty("children")
                                            ? f.children.map(
                                                (g: any) => (
                                                  this.machineListWithChild.push(
                                                    g
                                                  ),
                                                  g.hasOwnProperty("children")
                                                    ? g.children.map(
                                                        (h: any) => (
                                                          this.machineListWithChild.push(
                                                            h
                                                          ),
                                                          h.hasOwnProperty(
                                                            "children"
                                                          )
                                                            ? h.children.map(
                                                                (j: any) => (
                                                                  this.machineListWithChild.push(
                                                                    j
                                                                  ),
                                                                  j.hasOwnProperty(
                                                                    "children"
                                                                  )
                                                                    ? j.children.map(
                                                                        (
                                                                          k: any
                                                                        ) => (
                                                                          this.machineListWithChild.push(
                                                                            k
                                                                          ),
                                                                          k.hasOwnProperty(
                                                                            "children"
                                                                          )
                                                                            ? this.machineListWithChild.push(
                                                                                k
                                                                              )
                                                                            : ""
                                                                        )
                                                                      )
                                                                    : ""
                                                                )
                                                              )
                                                            : ""
                                                        )
                                                      )
                                                    : ""
                                                )
                                              )
                                            : ""
                                        )
                                      )
                                    : ""
                                )
                              )
                            : ""
                        )
                      )
                    : ""
                )
              )
            : ""
        )
      ),
      (this.machineListWithoutChild = []),
      (this.machineListWithoutChild = this.machineListWithChild.map(
        ({ children, ...rest }) => rest
      )),
      console.log("machineListWithoutChild", this.machineListWithoutChild),
      this._restService
        .updateMachineDetail(
          this.machineID,
          this.status,
          this.machineListWithoutChild,
          this.machineOrgIdParentENV,
          this.environmentId,
          this.isConfigEdit,
          this.isAccessEdit,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.isConfigEdit = 0),
            (this.isAccessEdit = 0),
            this._restService
              .getMachineDetail(
                this.machineOrgIdParentENV,
                this.machineID,
                this.masterEnvId,
                this.envType
              )
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  console.log("Vanaraj", f.systemAccess),
                  f.systemAccess.map(
                    (a: any) => (
                      (a.isSystemEdited = false),
                      a.hasOwnProperty("children")
                        ? a.children.map(
                            (b: any) => (
                              (b.isSystemEdited = false),
                              b.hasOwnProperty("children")
                                ? b.children.map(
                                    (c: any) => (
                                      (c.isSystemEdited = false),
                                      c.hasOwnProperty("children")
                                        ? c.children.map(
                                            (d: any) => (
                                              (d.isSystemEdited = false),
                                              d.hasOwnProperty("children")
                                                ? d.children.map(
                                                    (f: any) =>
                                                      (f.isSystemEdited = false),
                                                    f.hasOwnProperty("children")
                                                      ? f.children.map(
                                                          (g: any) => (
                                                            (g.isSystemEdited = false),
                                                            g.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? g.children.map(
                                                                  (h: any) => (
                                                                    (h.isSystemEdited = false),
                                                                    h.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? h.children.map(
                                                                          (
                                                                            j: any
                                                                          ) => (
                                                                            (j.isSystemEdited = false),
                                                                            j.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? j.children.map(
                                                                                  (
                                                                                    k: any
                                                                                  ) => (
                                                                                    (k.isSystemEdited = false),
                                                                                    k.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? k.children.map(
                                                                                          (
                                                                                            l: any
                                                                                          ) =>
                                                                                            (l.isSystemEdited = false)
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  ),
                  (this.systemList = f.systemAccess),
                  (SystemUtils.sortSystemAccess(this.systemList)),
                  (this.isLoading = false),
                  (this.isSuccess = true),
                  (this.successMessage = "Updated Successfully")
                )
              )
          )
        );
  }

  refresh() {
    (this.isLoading = true),
      this._restService
        .refreshMachineList(this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("Refresh machineLists", f),
            this._restService
              .getMachineLists()
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (d: any) => (
                  (this.machineLists = d.machineList),
                  (d.machineList.forEach(m => {
                    m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                    m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
                  })),
                  (this.filterArray = d.machineList),
                  (this.filterArraySize = d.machineList.length),
                  (this.Totalmachines = d.machineListLength),
                  (this.notConfigure = d.notConfigured),
                  (this.deleteMachineLength = d.deleteMachine),
                  (this.isLoading = false),
                  console.log(
                    "Data from Machine list ----------------->>>>>>>",
                    d
                  )
                )
              )
          )
        );
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }

  searchKeyword(e: any) {
    //console.log(e.target.value);
    let v = e.target.value.toLowerCase();
    this.filterArray = [];

    this.machineLists.map((f: any) =>
      f.MachineName.toLowerCase().includes(v) ||
      f.ModifiedDate.toLowerCase().includes(v)
        ? (this.filterArray.push(f),
          (this.filterArraySize = this.filterArray.length),
          console.log("FTR Length", this.filterArray.length))
        : ""
    );
  }

  updateConfigStatus(e: any) {
    this.setConfigStatus = e.target && e.target.checked;
    console.log(this.setConfigStatus);
  }

  updateSelectedMachine(machine: any, e: any) {
    if (e.target && e.target.checked) {
      this.selectedMachines.add(machine);
    } else {
      this.selectedMachines.delete(machine);
    }
  }

  applyConfig() {

    let machinesArr: any [] = Array.from(this.selectedMachines);
    machinesArr = machinesArr.filter(m => m.MachineId != this.selectedMachine.MachineId);

    if (!machinesArr || !machinesArr.length) {
      return;
    }

    this.isLoading = true;

    this.getMachineDetail(this.selectedMachine.Machine_OrgId_ParentENV, this.selectedMachine.MachineId, this.envType)
    .then (res => {
      this._restService
      .bulkConfigUpdate(this.setConfigStatus, machinesArr, 
        this.selectedMachine, (res as any).systemAccess, machinesArr)
      .pipe(
        catchError((e) => {
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.StatusInfo || (e.error && e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(response => {
        this.isLoading = false;
        this.isSuccess = true;
        this.successMessage = (response as any).StatusInfo;
      })
    })
    .catch (err=> {
      this.isLoading = false;
      this.isFailure = true;
      this.failureMessage = err.StatusInfo;
    })
    
  }
}
